
<div class="modal-header align-items-center text-secondary pb-1">
	<div>
		<h3 class="font-weight-bold  mb-1">Choose Travel Board</h3>
	</div>
    <button type="button" class="modal-close ml-auto" aria-label="Close" (click)="closeModal()"><fa-icon [icon]="['fas', 'times']"></fa-icon></button>
</div>
<div class="modal-body text-primary pt-1">

	<div class="text-muted">Most recent</div>
	<div class="b-gray-300 rounded-corners mb-3 boards-list">
		<ng-container *ngIf="boards$ | async as boards; else noboards">
			<div *ngFor="let board of boards; let i = index; let last = last;"
				class="d-flex align-items-center tbli "
				[ngClass]="{'mb-1': i != last}"
				(click)="onSelectBoard(board)"
				>
				<span class="font-weight-medium">{{board.name}}</span>
				<div class="btn btn-primary pill small ml-auto btn-save">Save</div>
			</div>
		</ng-container>

		<ng-template #noboards>
			<div class="font-weight-medium">No Travel Boards found for this user.</div>
		</ng-template>
	</div>

	<div class="btn btn-link text-left pl-0" (click)="onCreateBoard()">
		<fa-icon [icon]="['fas', 'plus']" class="mr-1 fa-xs"></fa-icon>
		<span class="font-weight-medium">Create New Travel Board</span>
	</div>

</div>
<!-- <div class="modal-footer">
    
	
</div> -->



<!-- <div class="text-small text-danger">productId: {{productId}}</div>  -->